import { Clock } from "lucide-react";
import { fValor } from "../../lib/trading";
import { TC, TvChart } from "./TvChart";
import { TradingPanel } from "./Panel";

const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const M = (v) => fValor(v, "money");

// Originación por mes (barras) con línea de referencia del pipeline abierto.
export const ColocacionTv = ({ data, pipeline }) => {
  const labels = data.map((x) => `${MES[Number(x.mes.slice(5)) - 1]} ${x.mes.slice(2, 4)}`);
  const series = [{ id: "monto", name: "Originación", type: "histogram", color: TC.up, data: data.map((x) => ({ value: x.monto })), fmt: M },
    { id: "n", name: "Créditos", type: "line", color: TC.accent, scale: "left", data: data.map((x) => ({ value: x.n })), fmt: (v) => v.toFixed(0) }];
  const tot = data.reduce((a, x) => a + x.monto, 0);
  return (
    <TradingPanel title="Originación por mes" ultimo={fValor(tot, "money", true)} cambio="12 meses" tono="flat" testid="tp-colocacion"
      como="Σ monto de créditos por mes de fecha de disposición (últimos 12 meses). Línea punteada: monto del pipeline abierto (excluye Dispuesto y Rechazado)." fuente="Inicio · colocación 12m + pipeline">
      <TvChart series={series} labels={labels} height={240} fmt={M} priceLines={pipeline ? [{ id: "monto", price: pipeline, title: "Pipeline" }] : []} testid="colocacion-chart" />
    </TradingPanel>
  );
};

// Pipeline por etapa estilo «order book / depth»: monto acumulado por etapa, Comité resaltado.
export const EmbudoDepth = ({ etapas }) => {
  const max = Math.max(1, ...etapas.map((e) => e.monto || 0));
  let acc = 0;
  return (
    <TradingPanel title="Pipeline por etapa · profundidad" ultimo={fValor(etapas.reduce((a, e) => a + (e.monto || 0), 0), "money", true)} cambio={`${etapas.reduce((a, e) => a + e.n, 0)} deals`} tono="flat" testid="inicio-embudo"
      como="Monto de recursos solicitados por etapa (barra) y acumulado de izquierda a derecha (sombra), número de deals y días promedio en la etapa. Comité resaltado." fuente="Pipeline (deals)">
      <div className="space-y-1" role="table">{etapas.map((e) => {
        acc += e.monto || 0;
        const com = e.id === "comite";
        return (
          <div key={e.id} role="row" className={`relative grid grid-cols-12 items-center gap-2 overflow-hidden rounded-md px-2 py-1.5 text-xs ${com ? "ring-1 ring-[var(--trd-accent)]" : ""}`} data-testid={`embudo-${e.id}`}>
            <div className="absolute inset-y-0 left-0 bg-[var(--trd-up)]/10" style={{ width: `${(acc / Math.max(1, etapas.reduce((a, x) => a + (x.monto || 0), 0))) * 100}%` }} />
            <div className={`absolute inset-y-1 left-0 rounded-r ${com ? "bg-[var(--trd-accent)]/50" : "bg-[var(--trd-up)]/35"}`} style={{ width: `${((e.monto || 0) / max) * 100}%` }} />
            <span className={`relative col-span-4 truncate font-semibold ${com ? "text-[var(--trd-accent)]" : "text-[#C9D1D9]"}`}>{e.label}</span>
            <span className="trd-mono relative col-span-2 text-right text-[var(--trd-muted)]">{e.n}</span>
            <span className="trd-mono relative col-span-4 text-right">{fValor(e.monto || 0, "money", true)}</span>
            <span className="trd-mono relative col-span-2 flex items-center justify-end gap-1 text-[var(--trd-muted)]"><Clock size={10} />{e.dias_prom == null ? "—" : `${e.dias_prom}d`}</span>
          </div>);
      })}</div>
    </TradingPanel>
  );
};
